import { TableERP } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetConciliacionBancariaByIdDtoProps } from "api/DTOs/GetConciliacionBancariaByIdDto"
import { TFunction } from "i18next"
import { MODAL_DOCUMENTOS_CUENTAS_BANCARIAS_CONCILIADAS_COLUMNS } from "../../BancosDetail/components/ModalDocumentosConciliados/ModalCuentasBancariasColumns"
import { MODAL_DOCUMENTOS_CONCILIADAS_COLUMNS } from "../../BancosDetail/components/ModalDocumentosConciliados/ModalDocumentosConciliadas"

const TablaConciliadas = ({
  isUpperSectionExpanded,
  toggleUpperSection,
  t,
  conciliacionBancariaById,
  isUpperSectionExpandedSecond,
  toggleUpperSectionSecond,
}: {
  isUpperSectionExpanded: boolean
  toggleUpperSection: () => void
  t: TFunction
  conciliacionBancariaById: GetConciliacionBancariaByIdDtoProps
  isUpperSectionExpandedSecond: boolean
  toggleUpperSectionSecond: () => void
}) => {
  return (
    <div className='tw-flex tw-flex-col tw-h-[calc(100%-80px)]'>
      <section
        className={`${
          isUpperSectionExpanded ? "tw-max-h-1/2 tw-h-auto" : "tw-h-12"
        } tw-items-center tw-overflow-hidden tw-transition-all tw-duration-100 tw-ease-in-out`}
      >
        <div
          className='tw-flex tw-h-14 tw-cursor-pointer tw-items-center tw-justify-between tw-pl-5 tw-pr-6'
          onClick={toggleUpperSection}
        >
          <div className='tw-flex tw-items-center'>
            <FontAwesomeIcon
              icon={["fal", "angle-right"]}
              className={`tw-h-5 tw-w-5 tw-text-gray-500 tw-transition-transform tw-duration-100 ${
                isUpperSectionExpanded ? "tw-rotate-90 tw-transform" : ""
              }`}
            />
            <span className='tw-ml-2 tw-select-none tw-font-medium'>
              {t("bancos.conciliacion.rightColumn.header")}
            </span>
          </div>
        </div>
        {isUpperSectionExpanded && (
          <div className='tw-scrollbar-thin tw-h-[calc(100dvh-75dvh)] tw-overflow-y-auto'>
            <TableERP
              columns={MODAL_DOCUMENTOS_CUENTAS_BANCARIAS_CONCILIADAS_COLUMNS(
                t
              )}
              className='tw-h-full tw-max-w-full'
              columnResizeMode='expand'
              removableSort
              value={conciliacionBancariaById?.movimientosBancarios ?? []}
              showGridlines
              dataKey='idExterno'
              lazy
              scrollable
              size='small'
              emptyMessage={`${t("nsAssets.modalAmortize.emptyMessage")}`}
            />
          </div>
        )}
      </section>
      <section
        className={`${
          isUpperSectionExpandedSecond ? "tw-h-auto" : "tw-h-12"
        } tw-items-center tw-overflow-hidden tw-transition-all tw-duration-100 tw-ease-in-out`}
      >
        <div
          className='tw-flex tw-h-14 tw-cursor-pointer tw-items-center tw-justify-between tw-pl-5 tw-pr-6'
          onClick={toggleUpperSectionSecond}
        >
          <div className='tw-flex tw-items-center'>
            <FontAwesomeIcon
              icon={["fal", "angle-right"]}
              className={`tw-h-5 tw-w-5 tw-text-gray-500 tw-transition-transform tw-duration-100 ${
                isUpperSectionExpandedSecond ? "tw-rotate-90 tw-transform" : ""
              }`}
            />
            <span className='tw-ml-2 tw-select-none tw-font-medium'>
              {t("bancos.conciliacion.modal.conciliadosDoc.header")}
            </span>
          </div>
        </div>
        {isUpperSectionExpandedSecond && (
          <div className='tw-scrollbar-thin tw-h-full tw-overflow-y-auto'>
            <TableERP
              columns={MODAL_DOCUMENTOS_CONCILIADAS_COLUMNS(t)}
              className='tw-h-full tw-max-w-full'
              columnResizeMode='expand'
              removableSort
              value={conciliacionBancariaById?.flujosTesoreria ?? []}
              showGridlines
              dataKey='idExterno'
              lazy
              scrollable
              size='small'
              emptyMessage={`${t("nsAssets.modalAmortize.emptyMessage")}`}
            />
          </div>
        )}
      </section>
    </div>
  )
}

export default TablaConciliadas
